import { useNavigate } from 'react-router-dom';
import { DeliveryProofListPage } from '@/features/delivery-proof/components/DeliveryProofListPage';

export const DeliveryProofList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <DeliveryProofListPage
      onCreateClick={() => navigate('/delivery-proofs/new')}
      onDraftClick={(dpId) => navigate(`/delivery-proofs/new?dpId=${dpId}`)}
      embedded
    />
  );
};
